export default __webpack_public_path__ + "static/media/RecebaInformacoesMb.3359f776.png";